// src/data/exhaustProducts.js

// ===== Exhaust products (your data kept exactly) =====
export const EXHAUST_PRODUCTS = [
  { id: "p1",  slug: "ul-catback-f90",    name: "BMW M5 F90",            basePrice: 2475, car: "Starting at",  img: "/assets/p-exh-01.jpg" },
  { id: "p2",  slug: "ul-catback-g90",    name: "BMW M5 G90 / G99",            basePrice: 3475, car: "Starting at:", img: "/assets/p-exh-02.jpg" },
  { id: "p3",  slug: "ul-catback-g82",     name: "BMW M4 G82",            basePrice: 2475, car: "Starting at",  img: "/assets/p-exh-03.jpg" },
  { id: "p4",  slug: "ul-catback-c63",    name: "Mercedes C63 W205",     basePrice: 2475, car: "Starting at",  img: "/assets/p-exh-04.jpg" },
  { id: "p5",  slug: "ul-catback-g63",  name: "Mercedes G63",          basePrice: 2499, car: "Starting at",  img: "/assets/p-exh-05.jpg" },
  { id: "p6",  slug: "ul-catback-rs6",     name: "Audi RS6/RS7",          basePrice: 2475, car: "Starting at",  img: "/assets/p-exh-06.jpg" },
  { id: "p7",  slug: "ul-catback-rs5",    name: "Audi RS5",              basePrice: 2275, car: "Starting at",  img: "/assets/p-exh-07.jpg" },
  { id: "p8",  slug: "ul-catback-e63",       name: "Mercedes E63 W213",     basePrice: 2999, car: "Starting at",  img: "/assets/p-exh-08.jpg" },
  { id: "p9",  slug: "ul-catback-r8",      name: "Audi R8",               basePrice: 3100, car: "Starting at",  img: "/assets/p-exh-09.jpg" },
  { id: "p10", slug: "ul-catback-huracan",    name: "Lamborghini Huracan",   basePrice: 4375, car: "Starting at",  img: "/assets/p-exh-10.jpg" },
  { id: "p11", slug: "ul-catback-r35",    name: "Nissan GT-R R35",       basePrice: 2975, car: "Starting at",  img: "/assets/p-exh-11.jpg" },
  { id: "p12", slug: "ul-valved-911", name: "Porsche 911 Carerra / S / GTS",           basePrice: 2975, car: "Starting at",  img: "/assets/p-exh-12.jpg" },
{ id: "p13", slug: "ul-catback-720s", name: "McLaren 720s", basePrice: 4275, car: "Starting at", img: "/assets/p-exh-13.jpg" },
{ id: "p14", slug: "ul-catback-570s", name: "McLaren 570s", basePrice: 4175, car: "Starting at", img: "/assets/p-exh-14.jpg" },
{ id: "p15", slug: "ul-catback-488", name: "Ferrari 488", basePrice: 4575, car: "Starting at", img: "/assets/p-exh-15.jpg" },
{ id: "p16", slug: "ul-catback-aventadorsvj", name: "Lamborghini Aventador SVJ / Ultimae", basePrice: 5375, car: "Starting at", img: "/assets/p-exh-16.jpg" },
{ id: "p17", slug: "ul-catback-urus", name: "Lamborghini Urus", basePrice: 4975, car: "Starting at", img: "/assets/p-exh-17.jpg" },
{ id: "p18", slug: "ul-catback-gt4", name: "Porsche GT4 RS", basePrice: 3275, car: "Starting at", img: "/assets/p-exh-18.jpg" },
{ id: "p19", slug: "ul-catback-gt3", name: "Porsche GT3 RS", basePrice: 3545, car: "Starting at", img: "/assets/p-exh-19.jpg" },
{ id: "p20", slug: "ul-catback-turbos", name: "Porsche Turbo S", basePrice: 3545, car: "Starting at", img: "/assets/p-exh-20.jpg" },
{ id: "p21", slug: "ul-catback-m2", name: "BMW M2 G87", basePrice: 2675, car: "Starting at", img: "/assets/p-exh-21.jpg" },
{ id: "p22", slug: "ul-catback-M8", name: "BMW M8", basePrice: 2975, car: "Starting at", img: "/assets/p-exh-22.jpg" },
{ id: "p23", slug: "ul-catback-M6", name: "BMW M6", basePrice: 2675, car: "Starting at", img: "/assets/p-exh-23.jpg" },
{ id: "p24", slug: "ul-catback-F10", name: "BMW M5 F10", basePrice: 2675, car: "Starting at", img: "/assets/p-exh-24.jpg" },
{ id: "p25", slug: "ul-catback-F80", name: "BMW M3 F80", basePrice: 2375, car: "Starting at", img: "/assets/p-exh-25.jpg" },
{ id: "p26", slug: "ul-catback-F87", name: "BMW M2 F87", basePrice: 2375, car: "Starting at", img: "/assets/p-exh-26.jpg" },
{ id: "p27", slug: "ul-catback-M340", name: "BMW M340I", basePrice: 2375, car: "Starting at", img: "/assets/p-exh-27.jpg" },
{ id: "p28", slug: "ul-catback-g80", name: "BMW M3 G80", basePrice: 2675, car: "Starting at", img: "/assets/p-exh-28.jpg" },
{ id: "p29", slug: "ul-catback-aventadors", name: "Lamborghini Aventador / S /SV", basePrice: 4975, car: "Starting at", img: "/assets/p-exh-29.jpg" },
{ id: "p30", slug: "ul-catback-750s", name: "McLaren 750S", basePrice: 4975, car: "Starting at", img: "/assets/p-exh-30.jpg" },
{ id: "p31", slug: "ul-catback-765LT", name: "McLaren 765LT", basePrice: 5175, car: "Starting at", img: "/assets/p-exh-31.jpg" },
{ id: "p32", slug: "ul-catback-supra", name: "Toyota Supra A90 / A91", basePrice: 2375, car: "Starting at", img: "/assets/p-exh-32.jpg" },
{ id: "p33", slug: "ul-catback-amggts", name: "Mercedes C192 AMG GT63", basePrice: 2975, car: "Starting at", img: "/assets/p-exh-33.jpg" },
{ id: "p34", slug: "ul-catback-amggt", name: "Mercedes C190 AMG GT / GTS / GTC", basePrice: 2375, car: "Starting at", img: "/assets/p-exh-34.jpg" },
{ id: "p35", slug: "ul-catback-rev", name: "Lamborghini Revuelto F1", basePrice: 6875, car: "Starting at", img: "/assets/p-exh-35.jpg" },
{ id: "p36", slug: "ul-catback-c8", name: "Corvette C8 Stingray", basePrice: 3550, car: "Starting at", img: "/assets/p-exh-36.jpg" },
{ id: "p37", slug: "ul-catback-Sl65", name: "Mercedes SL63/SL65 AMG R231", basePrice: 2350, car: "Starting at", img: "/assets/p-exh-37.jpg" },












];

// ===== Pricing knobs (shared) =====
export const EXHAUST_OPTION_PRICING = {
  muffler: {
    stainless: 0,
    titanium: 900,
  },
  tip: {
    silver: 0,
    gold: 0,
    blue: 0,
    black: 0,
    "carbon-fiber": 0,
  },
}; // <— IMPORTANT: this closing brace+semicolon must be here

// ===== Derive make/model from the name string (e.g., "BMW M5 F90") =====
function deriveMakeModel(name = "") {
  const firstSpace = name.indexOf(" ");
  if (firstSpace < 0) return { make: name.trim(), model: "" };
  const make = name.slice(0, firstSpace).trim();
  const model = name.slice(firstSpace + 1).trim(); // keep "M5 F90", "RS6/RS7", etc.
  return { make, model };
}

// ===== Normalized list we can filter on (for Make/Model dropdowns) =====
export const ALL_PRODUCTS = EXHAUST_PRODUCTS.map((p) => {
  const { make, model } = deriveMakeModel(p.name);
  return { ...p, make, model, category: "exhaust" };
});
